import React from "react";
import styled from "styled-components";
import { PageTitle } from "../components/common/PageData";

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
  background: #fff;
`;

const CenteredPageTitle = styled(PageTitle)`
  text-align: center;
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 30px;
  text-transform: uppercase;
  letter-spacing: 2px;

  @media (max-width: 768px) {
    font-size: 28px;
    letter-spacing: 1px;
  }
`;

const Content = styled.div`
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  line-height: 1.8;
  color: #333;

  h2 {
    font-size: 20px;
    font-weight: 600;
    margin-top: 30px;
    margin-bottom: 15px;
    color: #000;
  }

  p {
    margin-bottom: 20px;
    text-align: justify;
  }

  ul {
    margin: 20px 0;
    padding-left: 30px;
  }

  li {
    margin-bottom: 10px;
  }

  strong {
    font-weight: 600;
    color: #000;
  }
`;

const LastUpdate = styled.p`
  font-style: italic;
  color: #666;
  margin-bottom: 20px;
`;

export const PrivacyPolicy: React.FC = () => {
  return (
    <Container>
      <CenteredPageTitle>INFORMATIVA SULLA PRIVACY</CenteredPageTitle>
      <Content>
        <LastUpdate>
          Ultimo aggiornamento: 24 Agosto 2025<br />
          Data di entrata in vigore: 24 Agosto 2025
        </LastUpdate>

        <p>
          La presente Informativa sulla privacy descrive le politiche di CO2 Snowboarding ASD, via Berardo Maggi, Gavardo, BS 25085, Italia, email: info@co2snowboarding.it, telefono: 3286530434, in merito alla raccolta, all'utilizzo e alla divulgazione delle informazioni che raccogliamo quando utilizzi il nostro sito web (https://www.co2snowboarding.it) (il "Servizio"). Accedendo o utilizzando il Servizio, acconsenti alla raccolta, all'utilizzo e alla divulgazione delle tue informazioni in conformità con la presente Informativa sulla privacy. Se non acconsenti, ti preghiamo di non accedere o utilizzare il Servizio.
        </p>

        <p>
          Potremmo modificare la presente Informativa sulla Privacy in qualsiasi momento senza preavviso e pubblicheremo la versione aggiornata dell'Informativa sulla Privacy sul Servizio. L'Informativa aggiornata entrerà in vigore 180 giorni dopo la sua pubblicazione sul Servizio e il tuo accesso o utilizzo continuato del Servizio dopo tale termine costituirà la tua accettazione dell'Informativa sulla Privacy aggiornata. Ti consigliamo pertanto di consultare periodicamente questa pagina.
        </p>

        <h2>Informazioni che raccogliamo:</h2>
        <p>
          Raccoglieremo ed elaboreremo le seguenti informazioni personali su di te:
        </p>
        <ul>
          <li>Nome</li>
          <li>E-mail</li>
          <li>Mobile</li>
          <li>Data di nascita</li>
          <li>Indirizzo</li>
        </ul>

        <h2>Come utilizziamo le tue informazioni:</h2>
        <p>
          Utilizzeremo le informazioni che raccogliamo su di te per i seguenti scopi:
        </p>
        <ul>
          <li>Creazione di un account utente</li>
        </ul>
        <p>
          Se volessimo utilizzare le tue informazioni per qualsiasi altro scopo, ti chiederemo il consenso e utilizzeremo le tue informazioni solo dopo aver ricevuto il tuo consenso e, successivamente, solo per lo scopo per cui hai concesso il consenso, a meno che non siamo tenuti a fare diversamente per legge.
        </p>

        <h2>Conservazione delle tue informazioni:</h2>
        <p>
          Conserveremo i tuoi dati personali per un periodo compreso tra 90 giorni e 2 anni dopo la chiusura dell'account da parte dell'utente o per tutto il tempo necessario a soddisfare le finalità per cui sono stati raccolti, come specificato nella presente Informativa sulla privacy. Potremmo dover conservare determinate informazioni per periodi più lunghi, ad esempio per la tenuta dei registri/reporting in conformità con la legge applicabile o per altri motivi legittimi, come l'esercizio di diritti legali, la prevenzione delle frodi, ecc. Le informazioni anonime residue e le informazioni aggregate, nessuna delle quali ti identifica (direttamente o indirettamente), possono essere conservate a tempo indeterminato.
        </p>

        <h2>I tuoi diritti:</h2>
        <p>
          A seconda della legge applicabile, potresti avere il diritto di accedere ai tuoi dati personali, rettificarli o cancellarli o riceverne una copia, limitarne o opporti al trattamento attivo, chiederci di condividere (portare) i tuoi dati personali a un'altra entità, revocare qualsiasi consenso fornitoci per il trattamento dei tuoi dati, il diritto di presentare un reclamo a un'autorità competente e altri diritti rilevanti ai sensi della legge applicabile. Per esercitare tali diritti, puoi scriverci all'indirizzo info@co2snowboarding.it. Risponderemo alla tua richiesta in conformità con la legge applicabile.
        </p>
        <p>
          Puoi scegliere di non ricevere comunicazioni di marketing diretto o di non ricevere profilazione per finalità di marketing scrivendoci all'indirizzo info@co2snowboarding.it.
        </p>
        <p>
          Tieni presente che se non ci autorizzi a raccogliere o elaborare le informazioni personali richieste o ritiri il consenso al loro trattamento per gli scopi richiesti, potresti non essere in grado di accedere o utilizzare i servizi per i quali sono state richieste le tue informazioni.
        </p>

        <h2>Cookie ecc.</h2>
        <p>
          Per saperne di più su come li utilizziamo e sulle tue scelte in relazione a queste tecnologie di tracciamento, consulta la nostra Politica sui cookie.
        </p>

        <h2>Sicurezza:</h2>
        <p>
          La sicurezza delle tue informazioni è importante per noi e adotteremo misure di sicurezza ragionevoli per prevenire la perdita, l'uso improprio o l'alterazione non autorizzata delle tue informazioni sotto il nostro controllo. Tuttavia, dati i rischi intrinseci, non possiamo garantire la sicurezza assoluta e, di conseguenza, non possiamo assicurare o garantire la sicurezza di alcuna informazione che ci trasmetti, e lo fai a tuo rischio e pericolo.
        </p>

        <h2>Responsabile della protezione dei dati/reclami:</h2>
        <p>
          Per qualsiasi domanda o dubbio sul trattamento dei tuoi dati personali in nostro possesso, puoi inviare un'e-mail al nostro Responsabile dei Reclami presso CO2 Snowboarding ASD, via Berardo Maggi, Gavardo, all'indirizzo email: info@co2snowboarding.it. Risponderemo alle tue domande in conformità con la legge applicabile.
        </p>

        <p style={{ marginTop: "40px", fontSize: "14px", color: "#999", fontStyle: "italic" }}>
          Informativa sulla privacy generata con CookieYes.
        </p>
      </Content>
    </Container>
  );
};